module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAFFJREFUWEft1cENACAIQ1HYh/0n6T4YJ2jgwuV7xtq8xJBxfPL4/aAAAghYAUm9+apVZbN/rh2iAAIIIIAAAucCm004uWO34SRsM0sBBBBA4AHnSzghkamHLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/player/stop3.png
// module id = mhkQ
// module chunks = 1